module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch4"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch4.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_vm._v("“Ready for what?” you ask.")])]), _c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why, to travel in time, of course,” he replies. “You’ll be the first human in history to use my traveling chronometer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chronometer?” you echo. “What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He points to the stopwatch around your neck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have time —” you start to say, but he interrupts again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course you have time!” Dr. Peebles goes on. “It doesn’t matter how long you remain in the past or future. When you return to the present, it will be the same moment that you left. It will be as if you weren’t gone at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How does this work?” you ask, pointing to the stopwatch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s easy,” says Dr. Peebles. “Press the button on the left side to travel to the past. Press the button on the right for the future. To return to the present, press the top button and the bottom button at the same time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cool! you think. What if this guy’s invention really works? Traveling in time would be awesome!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no time to waste!” Dr. Peebles says. “I’m ready to begin the experiment now.”")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hurry to ")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841016_ch005"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 5")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3293186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841016_ch004.vue
// module id = 75
// module chunks = 0